var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutomationDarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.035,
    height: 12,
    viewBox: "0 0 12.035 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Automation_Rules_bllue",
    "data-name": "Automation Rules_bllue",
    transform: "translate(-10055 781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160891",
    "data-name": "Group 160891",
    transform: "translate(10055 -781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160890",
    "data-name": "Group 160890"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140092",
    "data-name": "Rectangle 140092",
    width: 12,
    height: 12,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160827",
    "data-name": "Group 160827",
    transform: "translate(2986.13 -354.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M0,0H11.662V11.662H0Z",
    transform: "translate(7069.243 -426.526)",
    fill: "none",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Automation_Rules_gray",
    "data-name": "Automation Rules_gray",
    transform: "translate(10053.051 -782.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M6.992,3.663A1.039,1.039,0,0,1,5.6,4.2,1.05,1.05,0,0,0,4.2,5.6a1.039,1.039,0,0,1-.542,1.395,1.037,1.037,0,0,0,0,1.915A1.039,1.039,0,0,1,4.2,10.3,1.05,1.05,0,0,0,5.6,11.693a1.039,1.039,0,0,1,1.395.542,1.037,1.037,0,0,0,1.915,0,1.039,1.039,0,0,1,1.395-.542A1.05,1.05,0,0,0,11.693,10.3a1.039,1.039,0,0,1,.542-1.395,1.037,1.037,0,0,0,0-1.915A1.039,1.039,0,0,1,11.693,5.6,1.05,1.05,0,0,0,10.3,4.2a1.039,1.039,0,0,1-1.395-.542A1.037,1.037,0,0,0,6.992,3.663Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#2d68fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M12.292,10.646A1.646,1.646,0,1,1,10.646,9,1.646,1.646,0,0,1,12.292,10.646Z",
    transform: "translate(-2.697 -2.697)",
    fill: "none",
    stroke: "#2d68fe",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationDarkIcon);
export default __webpack_public_path__ + "static/media/automation-dark-icon.3426aa2007341039f109ab4cb5820862.svg";
export { ForwardRef as ReactComponent };